module.exports = __webpack_public_path__ + "img/btn-app@2x.fbb8a31f.png";